<div class="modal-content modal-milvus">
    <div class="modal-header-milvus align-items-center">
        <div class="col-8 header-col">
            <span class="modal-title" *ngIf="create" [translate]="'CRIAR_FILTRO_AVANCADO'"></span>
            <span class="modal-title" *ngIf="!create" [translate]="'EDITAR_FILTRO_AVANCADO'"></span>
        </div>
        <div class="col-4 header-col">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
                <i class="mdi mdi-close"></i>
            </button>
        </div>
    </div>

    <div class="modal-body modal-body-v2" [formGroup]="filtroForm">
        <div class="row">
            <div class="col-6 form-group">
                <label [translate]="'NOME_FILTRO'"></label>
                <input type="text" class="form-control" formControlName="nome" required
                    [ngClass]="{'required': filtroForm.controls.nome.hasError('required')}">
            </div>
            <div class="col-6 form-group">
                <label [translate]="'VISIBILIDADE'"></label>
                <select-padrao [selectModalPequeno]="true" [entidade]="'selectVisibilidadeFiltros'"
                    [model]="{id: filtroForm.value.visibilidade_id, text: ''}" [required]="true"
                    (selectChange)="filtroForm.patchValue({visibilidade_id: $event})"></select-padrao>
            </div>
        </div>

        <div class="stepper-wrapper">
            <div class="stepper-line"></div>

            <div class="step-row">
                <div class="step-icon">
                    <button type="button" class="btn btn-outline-secondary-milvus circled-btn custom-circle-btn">
                        <i class="mdi mdi-clock-outline"></i>
                    </button>
                </div>
                <div class="step-content">
                    <div class="step-title">
                        <span [translate]="'PERIODO'"></span>
                        <img src="assets/img/icons/svg/alert-icon.svg" alt="alert-icon" width="15px" height="15px"
                            class="svg-alert-icon icon-info-wf" container="body" tooltipClass="tooltip-info-filtro-avancado" [animation]="false"
                            [ngbTooltip]="this.translate.instant('TOOLTIP_ADD_PERIODO')" placement="bottom">
                    </div>
                    <button type="button" class="btn btn-success badge-pill" (click)="openPeriodo()">
                        <i class="mdi mdi-plus"></i>
                        <span [translate]="'ADD_PERIODO'"></span>
                    </button>

                    <div class="summary-list mt-3" *ngIf="periodos.length > 0">
                        <div class="summary-item"
                            *ngFor="let periodo of periodos.controls; let i = index; trackBy:trackByIndex">
                            <span class="logical-badge"
                                *ngIf="periodo.value.operador_logico_id">{{periodo.value.operador_logico_id === 2 ? 'OU'
                                : 'E'}}</span>
                            <span>{{periodo.value.campo_text}} • {{getOperadorPeriodoText(periodo.value.operador_id)}} •
                                {{formatValorPeriodo(periodo.value)}}</span>
                            <button type="button" class="btn btn-sm btn-success min-small-circled-btn"
                                (click)="openPeriodo(i)"><i class="fas fa-pen"></i></button>
                            <button type="button" class="btn btn-sm btn-danger min-small-circled-btn"
                                (click)="removePeriodo(i)"><i class="far fa-trash-alt"></i></button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="step-row mt-5">
                <div class="step-icon">
                    <button type="button" class="btn btn-outline-warning-milvus circled-btn custom-circle-btn">
                        <i class="mdi mdi-shuffle-variant"></i>
                    </button>
                </div>
                <div class="step-content">
                    <div class="step-title">
                        <span [translate]="'CONDICAO_E'"></span>
                        <img src="assets/img/icons/svg/alert-icon.svg" alt="alert-icon" width="15px" height="15px"
                            class="svg-alert-icon icon-info-wf" container="body" tooltipClass="tooltip-info-filtro-avancado" [animation]="false"
                            [ngbTooltip]="this.translate.instant('TOOLTIP_ADD_CONDICAO_E')" placement="bottom">
                    </div>
                    <button type="button" class="btn btn-success badge-pill" (click)="openCondicao()">
                        <i class="mdi mdi-plus"></i>
                        <span [translate]="'ADD_CONDICAO_E'"></span>
                    </button>

                    <div class="summary-list mt-3" *ngIf="condicoes.length > 0">
                        <div class="summary-item"
                            *ngFor="let condicao of condicoes.controls; let i = index; trackBy:trackByIndex">
                            <span class="logical-badge" *ngIf="i > 0">E</span>
                            <span>{{condicao.value.campo_text}} •
                                {{getOperadorCondicaoText(condicao.value.operador_id)}} •
                                {{formatValorCondicao(condicao.value)}}</span>
                            <button type="button" class="btn btn-sm btn-success min-small-circled-btn"
                                (click)="openCondicao(null, i)"><i class="fas fa-pen"></i></button>
                            <button type="button" class="btn btn-sm btn-danger min-small-circled-btn"
                                (click)="removeCondicao(i)"><i class="far fa-trash-alt"></i></button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="step-row mt-5"
                *ngFor="let grupo of grupos.controls; let gi = index; trackBy:trackByIndex">
                <div class="step-icon">
                    <button type="button" class="btn btn-outline-warning-milvus circled-btn custom-circle-btn">
                        <i class="mdi mdi-shuffle-variant"></i>
                    </button>
                </div>
                <div class="step-content">
                    <div class="step-title">
                        <span [translate]="'CONDICAO_OU'"></span>
                        <span class="star-required">*</span>
                        <img src="assets/img/icons/svg/alert-icon.svg" alt="alert-icon" width="15px" height="15px"
                            class="svg-alert-icon icon-info-wf" container="body" tooltipClass="tooltip-info-filtro-avancado" [animation]="false"
                            [ngbTooltip]="this.translate.instant('TOOLTIP_ADD_CONDICAO_E')" placement="bottom">
                        <button *ngIf="getCondicoesGrupo(gi).length === 0" type="button"
                            class="btn btn-sm btn-danger min-small-circled-btn" (click)="removeGrupo(gi)"><i
                                class="far fa-trash-alt"></i></button>
                    </div>

                    <div class="summary-list mb-2" *ngIf="getCondicoesGrupo(gi).length > 0">
                        <div class="summary-item"
                            *ngFor="let condicao of getCondicoesGrupo(gi).controls; let ci = index; trackBy:trackByIndex">
                            <span class="logical-badge" *ngIf="ci > 0">E</span>
                            <span>{{condicao.value.campo_text}} •
                                {{getOperadorCondicaoText(condicao.value.operador_id)}} •
                                {{formatValorCondicao(condicao.value)}}</span>
                            <button type="button" class="btn btn-sm btn-success min-small-circled-btn"
                                (click)="openCondicao(gi, ci)"><i class="fas fa-pen"></i></button>
                            <button type="button" class="btn btn-sm btn-danger min-small-circled-btn"
                                (click)="removeCondicao(ci, gi)"><i class="far fa-trash-alt"></i></button>
                        </div>
                    </div>

                    <div class="empty-group mb-2" *ngIf="getCondicoesGrupo(gi).length === 0">Grupo sem condições.
                    </div>

                    <button type="button" class="btn btn-success badge-pill" (click)="openCondicao(gi)">
                        <i class="mdi mdi-plus"></i>
                        <span [translate]="'ADD_CONDICAO_E'"></span>
                    </button>
                </div>
            </div>

            <div class="step-row mt-5">
                <div class="step-icon">
                    <button type="button" class="btn btn-outline-warning-milvus circled-btn custom-circle-btn">
                        <i class="mdi mdi-shuffle-variant"></i>
                    </button>
                </div>
                <div class="step-content">
                    <div class="step-title">
                        <span [translate]="'NOVO_GRUPO_CONDICOES'"></span>
                        <img src="assets/img/icons/svg/alert-icon.svg" alt="alert-icon" width="15px" height="15px"
                            class="svg-alert-icon icon-info-wf" container="body" tooltipClass="tooltip-info-filtro-avancado" [animation]="false"
                            [ngbTooltip]="this.translate.instant('TOOLTIP_ADD_GRUPO_CONDICOES')" placement="top">
                    </div>
                    <button *ngIf="grupos.length < maxGruposCondicoes" type="button" class="btn btn-success badge-pill"
                        (click)="novoGrupo()">
                        <i class="mdi mdi-plus"></i>
                        <span [translate]="'NOVO_GRUPO_CONDICOES'"></span>
                    </button>
                </div>
            </div>

            <div class="step-row mt-5">
                <div class="step-icon">
                    <button type="button" class="btn btn-outline-default-milvus circled-btn custom-circle-btn">
                        <i class="mdi mdi-check"></i>
                    </button>
                </div>
                <div class="step-content">
                    <div class="step-title">
                        <span [translate]="'FIM'"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <div class="w-100 d-flex justify-content-end">
            <button type="button" class="btn btn-md btn-success badge-pill d-flex" [disabled]="!canSave()"
                (click)="salvaFiltro()">
                <i class="mdi mdi-content-save-outline font-19"></i>
                <span [translate]="'SALVAR'"></span>
            </button>
        </div>
    </div>
</div>